export default `query getDeliveryData($cart_id: String!, $dest_country: String, $order_date: String!) {
  getDeliveryDataForAllShippings(
    cart_id: $cart_id,
    dest_country: $dest_country,
    order_date: $order_date
  )
}`;
